import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { MultiDateRangeComponent } from './multi-date-range.component';
import { LFDropdownModule } from '../../../../shared/dropdown/dropdown.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
    imports: [
        SharedModule,
        LFDropdownModule.forRoot(),
        MatDatepickerModule,
        MatMomentDateModule,
    ],
    declarations: [MultiDateRangeComponent],
    exports: [MultiDateRangeComponent],
})
export class MultiDateRangeModule
{
}
